<!-- 承运商档案>新增>基础信息 -->
<template>
  <div id="baseInfo">
    <div class="formbox">
      <el-form :model="baseInForm" :rules="rules" ref="baseInForm" label-width="110px" class="glo_formBox">
        <el-form-item label="承运商名称:" prop="carrierName">
          <el-input v-model="baseInForm.carrierName" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="承运商编号:" prop="carrierNumber">
          <el-input v-model="baseInForm.carrierNumber" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="审核状态:" prop="approveStatus">
          <el-select v-model="baseInForm.approveStatus" placeholder="请选择" disabled>
            <el-option label="待审核" value="shen_he_zhong:approve_status" />
            <el-option label="已审核" value="tong_guo:approve_status" />
            <el-option label="已审核" value="ju_jue:approve_status" />
          </el-select>
        </el-form-item>
        <el-form-item label="系统账号:" prop="userId">
          <el-select
            v-model="baseInForm.userId"
            clearable
            remote
            filterable
            :remote-method="remoteAccount"
            :loading="AccountPage.loading"
            v-loadmore:loadmore="'getAccountDownList'"
            @clear="remoteAccount('')"
            placeholder="输入账号进行匹配"
          >
            <el-option v-for="(item, index) in userArr" :key="index" :label="item.username" :value="item.userId" />
          </el-select>
        </el-form-item>
        <el-form-item label="所属网点:" prop="deptId">
          <!-- <el-select
            v-model="baseInForm.deptId"
            clearable
            remote
            filterable
            :remote-method="remoteDeptId"
            :loading="DeptPage.loading"
            v-loadmore:loadmore="'getDeptList'"
            @clear="remoteDeptId('')"
            placeholder="输入网点进行匹配"
          >
            <el-option v-for="(item, index) in departments" :key="index" :label="item.departmentName" :value="item.deptId" />
          </el-select> -->
          <el-select
              filterable
              clearable
              v-model="baseInForm.deptId"
              placeholder="请选择"
            >
              <el-option
                v-for="dept in businessDepts"
                :key="dept.deptId"
                :label="dept.deptName"
                :value="dept.deptId"
              ></el-option>
            </el-select>
        </el-form-item>
        <!-- <el-form-item label="合同编号:" prop="contractNo">
          <el-input v-model="baseInForm.contractNo" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="合同开始时间:" label-width="120px" prop="contractStartDate">
          <el-date-picker v-model="baseInForm.contractStartDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
        </el-form-item>
        <el-form-item label="合同结束时间:" label-width="120px" prop="contractEndDate">
          <el-date-picker v-model="baseInForm.contractEndDate" value-format="yyyy-MM-dd" type="date" placeholder="选择日期" />
        </el-form-item>-->
        <el-form-item label="联系人:" prop="contactsName">
          <el-input v-model="baseInForm.contactsName" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="联系电话:" prop="tel">
          <el-input v-model="baseInForm.tel" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="手机号码:" prop="phone">
          <el-input v-model="baseInForm.phone" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="是否停用:" prop="isStop">
          <el-select v-model="baseInForm.isStop" placeholder="请选择">
            <el-option label="是" :value="1" />
            <el-option label="否" :value="0" />
          </el-select>
        </el-form-item>

        <el-form-item style="width: 100%; border: 0" label="联系地址:" required>
          <div class="disFlexs">
            <el-select class="selectAddress" v-model="baseInForm.provinceName" @change="changeProvince" placeholder="请选择省" clearable filterable>
              <el-option v-for="(item, index) in provinceArr" :key="index" :label="item.districtName" :value="item.districtName" />
            </el-select>
            <el-select class="selectAddress" v-model="baseInForm.cityName" @change="changeCity" placeholder="请选择市" clearable filterable>
              <el-option v-for="(item, index) in cityArr" :key="index" :label="item.districtName" :value="item.districtName" />
            </el-select>
            <el-select class="selectAddress" v-model="baseInForm.areaName" placeholder="请选择区" clearable filterable>
              <el-option v-for="(item, index) in districtArr" :key="index" :label="item.districtName" :value="item.districtName" />
            </el-select>
            <el-input class="selectAddress addressDetails" v-model="baseInForm.address" placeholder="请输入详细地址" clearable />
          </div>
        </el-form-item>
        <el-form-item label="结算方式:" prop="settlementMethodConfDictId">
          <el-select v-model="baseInForm.settlementMethodConfDictId" placeholder="请选择">
            <el-option v-for="(item, index) in CollectionArr" :key="index" :label="item.val" :value="item.confDictId" />
          </el-select>
        </el-form-item>
        <el-form-item label="付款账期:" required>
          <el-input v-model="baseInForm.settlementPeriod" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="账期计算方式:" prop="periodSumMethod">
          <el-select v-model="baseInForm.periodSumMethod" placeholder="请选择">
            <el-option label="按日计算" value="day:period_sum_method" />
            <el-option label="按月计算" value="month:period_sum_method" />
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="结算周期:" prop="settlementPeriod">
          <el-input v-model="baseInForm.settlementPeriod" placeholder="请输入" clearable />
        </el-form-item>-->
        <el-form-item label="是否开票:" prop="isInvoice">
          <el-select v-model="baseInForm.isInvoice" placeholder="请选择">
            <el-option label="是" :value="1" />
            <el-option label="否" :value="0" />
          </el-select>
        </el-form-item>
        <el-form-item label="税点:" prop="taxPoint">
          <div class="disFlex">
            <el-input v-model="baseInForm.taxPoint" placeholder="请输入" clearable />
            <div>(%)</div>
          </div>
        </el-form-item>
        <el-form-item label="票据类型:" prop="invoiceTypeConfDictId">
          <el-select v-model="baseInForm.invoiceTypeConfDictId" placeholder="请选择">
            <el-option v-for="(item, index) in invoiceTypes" :key="index" :label="item.key" :value="item.confDictId" />
          </el-select>
        </el-form-item>
        <el-form-item label="负责人:" prop="personInChargeId">
          <el-select
            v-model="baseInForm.personInChargeId"
            clearable
            remote
            filterable
            :remote-method="remoteObject"
            :loading="SalesmanPage.loading"
            v-loadmore:loadmore="'getObjectUserDownList'"
            @clear="remoteObject('')"
            placeholder="输入负责人进行匹配"
          >
            <el-option v-for="(item, index) in personInCharges" :key="index" :label="item.name" :value="item.documentId" />
          </el-select>
        </el-form-item>

        <el-form-item class="textArea" style="width: 100%" label="备注:" prop="remarks">
          <el-input type="textarea" rows="2" v-model="baseInForm.remarks" />
        </el-form-item>

        <el-form-item label="收款对象:">
          <el-input v-model="baseInForm.collecatinAccountInfo.accountName" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="收款方式:">
          <el-select v-model="baseInForm.collecatinAccountInfo.refundConfDictId" placeholder="请选择">
            <el-option v-for="(item, index) in CollectionArr" :key="index" :label="item.key" :value="item.confDictId" />
          </el-select>
        </el-form-item>
        <el-form-item label="联系电话:">
          <el-input v-model="baseInForm.collecatinAccountInfo.tel" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="手机号码:">
          <el-input v-model="baseInForm.collecatinAccountInfo.phone" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="银行名称:">
          <el-input v-model="baseInForm.collecatinAccountInfo.bankName" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="银行账号:">
          <el-input v-model="baseInForm.collecatinAccountInfo.bankAccount" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item class="textArea" style="width: 100%" label="开户行地址:">
          <el-input type="textarea" rows="2" v-model="baseInForm.collecatinAccountInfo.bankAddress" />
        </el-form-item>
        <el-form-item label="证件名称:">
          <el-input v-model="baseInForm.collecatinAccountInfo.idcardName" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item label="证件号码:">
          <el-input v-model="baseInForm.collecatinAccountInfo.idcardNumber" placeholder="请输入" clearable />
        </el-form-item>
        <el-form-item class="textArea" style="width: 100%" label="备注:">
          <el-input type="textarea" rows="2" v-model="baseInForm.collecatinAccountInfo.remarks" />
        </el-form-item>
      </el-form>
    </div>
    <div class="btmBtns">
      <el-button class="glo_bgcMainColor saveBtns" @click="submit">保 存</el-button>
    </div>
  </div>
</template>
<script >
export default {
  components: {},
  props: {
    common: {
      type: Object,
    },
  },
  emits: ["RELOADPAGE"],
  data() {
    return {
      carrierId: this.common.carrierId,
      CollectionArr: [],
      personInCharges: [],
      invoiceTypes: [],
      departments: [],
      userArr: [],
      provinceArr: null,
      cityArr: null,
      districtArr: null,
      baseInForm: {
        provinceName: "",
        cityName: "",
        areaName: "",
        approveStatus: "shen_he_zhong:approve_status",
        isStop: 0,
        periodSumMethod: "month:period_sum_method",
        collecatinAccountInfo: {
          accountName: "",
          refundConfDictId: "",
          tel: "",
          phone: "",
          bankName: "",
          bankAccount: "",
          bankAddress: "",
          idcardName: "",
          idcardNumber: "",
          remarks: "",
        },
      },
      rules: {
        carrierName: [
          { required: true, message: "请输入名称", trigger: "blur" },
        ],
        carrierNumber: [
          { required: true, message: "请输入编号", trigger: "blur" },
        ],
        tel: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
        contactsName: [
          { required: true, message: "请输入联系人", trigger: "blur" },
        ],
        approveStatus: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        settlementMethodConfDictId: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        personInChargeId: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        periodSumMethod: [
          { required: true, message: "请选择", trigger: "change" },
        ],
        isStop: [{ required: true, message: "请选择", trigger: "change" }],
        isInvoice: [{ required: true, message: "请选择", trigger: "change" }],
      },
      DeptPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
        loading: false,
      },
      AccountPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
        loading: false,
      },
      SalesmanPage: {
        pageStart: 1,
        pageTotal: 20,
        pageCount: 0,
        loading: false,
      },
      businessDepts:[]
    };
  },
  watch: {
    common: {
      handler(nv, ov) {
        this.carrierId = nv.carrierId;
        this.GetData();
      },
      deep: true,
    },
  },
  activated() {},
  created() {
    if (this.carrierId) this.GetData();
    this.getParentName("中华人民共和国"); //默认查到各省
    this.getObjectUserDownList();
    this.GetConfDictValDownList("invoice_type");
    this.GetConfDictValDownList("out_going_settlement_method");
    //this.getDeptList();
    this.getBusinessDepts()
    this.getAccountDownList();
  },
  methods: {
    async getBusinessDepts() {
      const data = await this.$API.runListReport({
        number: "business_dept_down_list",
      });
      this.businessDepts = data
      this.businessDepts.map(item=>item.deptId = item.deptId + '');
    },
    // 获取承运商单条数据
    async GetData() {
      await this.$API.CarrierList({ carrierId: this.carrierId }).then((res) => {
        if (res.data.status === "success") {
          let datas = res.data.result?.data[0] || {};
          console.log(datas);
          if (!datas.collecatinAccountInfo) {
            datas.collecatinAccountInfo = {
              accountName: "",
              refundConfDictId: "",
              tel: "",
              phone: "",
              bankName: "",
              bankAccount: "",
              bankAddress: "",
              idcardName: "",
              idcardNumber: "",
              remarks: "",
            };
          }
          this.baseInForm = datas;
          this.getCityName(datas.provinceName || "");
          this.getAreaName(datas.cityName || "");
        } else {
          this.$message.error(res.data.message);
        }
      });
      await this.$API
        .carriergetCollecationAccount({ carrierId: this.carrierId })
        .then((res) => {
          if (res.data.status === "success") {
            this.baseInForm.collecatinAccountInfo = res.data.result || {};
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    // 获取负责人
    getObjectUserDownList(e, checkedData) {
      let query = {
        pageStart: this.SalesmanPage.pageStart,
        pageTotal: this.SalesmanPage.pageTotal,
        name: e,
        key: "employee",
        number: checkedData,
      };
      this.$API
        .wtl_getObjectUserDownList(query)
        .then((res) => {
          this.SalesmanPage.loading = false;
          if (res.data.status === "success") {
            let result = res.data.result?.data || [];
            let arr = this.personInCharges;
            if (e) {
              this.personInCharges = result;
            } else {
              this.personInCharges = [
                ...arr,
                ...result.filter(
                  (item) => !arr.some((x) => x.number === item.number)
                ),
              ];
            }
            if (!e && !checkedData) {
              this.SalesmanPage.pageCount = res.data.result?.pageCount || 0;
            }
          } else {
            this.$message.error(`${res.data.message}`);
          }
        })
        .catch((catchres) => {
          this.SalesmanPage.loading = false;
        });
    },
    // 责任人远程搜索
    remoteObject(e) {
      this.SalesmanPage.pageStart = 1;
      if (e !== "") {
        this.SalesmanPage.loading = true;
        this.getObjectUserDownList(e);
      } else {
        this.getObjectUserDownList();
      }
    },
    // 获取网点
    getDeptList(e, checkedData) {
      let query = {
        pageStart: this.DeptPage.pageStart,
        pageTotal: this.DeptPage.pageTotal,
        deptName: e,
        deptId: checkedData,
      };
      this.$API
        .wtl_getDeptList(query)
        .then((res) => {
          this.DeptPage.loading = false;
          if (res.data.status === "success") {
            let result = res.data.result?.data || [];
            let arr = this.departments;
            if (e) {
              this.departments = result;
            } else {
              this.departments = [
                ...arr,
                ...result.filter(
                  (item) => !arr.some((x) => x.deptId === item.deptId)
                ),
              ];
            }
            if (!e && !checkedData) {
              this.DeptPage.pageCount = res.data.result?.pageCount || 0;
            }
          } else {
            this.$message.error(res.data.message);
          }
        })
        .catch((catchres) => {
          this.DeptPage.loading = false;
        });
    },
    // 所属网点远程搜索
    remoteDeptId(e) {
      this.DeptPage.pageStart = 1;
      if (e !== "") {
        this.DeptPage.loading = true;
        this.getDeptList(e);
      } else {
        this.getDeptList();
      }
    },
    // 滚动条加载更多
    loadmore(e) {
      let definePage =
        e === "getObjectUserDownList"
          ? "SalesmanPage"
          : e === "getDeptList"
          ? "DeptPage"
          : e === "getAccountDownList"
          ? "AccountPage"
          : "";

      let count = this[definePage].pageCount / this[definePage].pageTotal;
      if (count > this[definePage].pageStart) {
        this[definePage].loading = true;
        this[definePage].pageStart += 1;
        this[e.replace(/[0-9]+/g, "")]();
      } else {
        console.log("数据已全部加载");
      }
    },

    // 获取系统账号
    getAccountDownList(e, checkedData) {
      let query = {
        pageStart: this.AccountPage.pageStart,
        pageTotal: this.AccountPage.pageTotal,
        // userType: "carrier:user_type",
        name: e,
        userId: checkedData,
      };
      this.$API
        .AccountDownList(query)
        .then((res) => {
          this.AccountPage.loading = false;
          if (res.data.status === "success") {
            let result = res.data.result?.data || [];
            let arr = this.userArr;
            if (e) {
              this.userArr = result;
            } else {
              this.userArr = [
                ...arr,
                ...result.filter(
                  (item) => !arr.some((x) => x.userId === item.userId)
                ),
              ];
            }
            if (!e && !checkedData) {
              this.AccountPage.pageCount = res.data.result?.pageCount || 0;
            }
          } else {
            this.$message.error(`${res.data.message}`);
          }
        })
        .catch((catchres) => {
          this.AccountPage.loading = false;
        });
    },
    // 系统账号远程搜索
    remoteAccount(e) {
      this.AccountPage.pageStart = 1;
      if (e !== "") {
        this.AccountPage.loading = true;
        this.getAccountDownList(e);
      } else {
        this.getAccountDownList();
      }
    },

    // 获取字典数据--票据类型、支付方式
    GetConfDictValDownList(param) {
      this.$API.getConfDictValDownList({ dictType: param }).then((res) => {
        if (res.data.status === "success") {
          if (param === "invoice_type") {
            this.invoiceTypes = res.data.result;
          }
          if (param === "out_going_settlement_method") {
            this.CollectionArr = res.data.result;
          }
        } else {
          this.$message.error(`${res.data.message}`);
        }
      });
    },

    // // 获取行政区
    // getDistrictDownList(param) {
    //   this.$API.DistrictDownList({ parentId: param }).then((res) => {
    //     if (res.data.status === "success") {
    //       let result = res.data.result;
    //       let district = result[0]?.level || "";
    //       let province = "provinceArr";
    //       let city = "cityArr";
    //       let area = "districtArr";
    //       if (district === "province") this[province] = result;
    //       if (district === "city") this[city] = result;
    //       if (district === "district") this[area] = result;
    //     }
    //   });
    // },
    // // 目的
    // districtClick(val, level) {
    //   console.log(this.provinceArr.find(n=>{n.}))
    //   // let id = parseInt();
    //   if (level === "province") {

    //     this.getDistrictDownList(val);
    //     this.cityArr = [];
    //   }
    //   if (level === "city") {
    //     this.getDistrictDownList(val);
    //     this.districtArr = [];
    //   }
    // },
    // 选择省(收货地址)
    changeProvince(e) {
      this.baseInForm.cityName = "";
      this.baseInForm.areaName = "";
      this.cityArr = [];
      this.districtArr = [];
      if (e) {
        this.getCityName(e);
      }
    },
    // 选择市(收货)
    changeCity(e) {
      this.baseInForm.areaName = "";
      this.districtArr = [];
      if (e) {
        this.getAreaName(e);
      }
    },
    // 默认查省级
    getParentName(e) {
      let p = {
        pageStart: 1,
        pageTotal: 100,
        parentName: e,
      };
      this.$API.wtl_getDistrictList(p).then((res) => {
        this.provinceArr = res.data.result.data || [];
      });
    },
    // 获取市
    getCityName(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.cityArr = res.data.result.data || [];
        });
    },
    // 获取区
    getAreaName(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.districtArr = res.data.result.data || [];
        });
    },
    submit() {
      // 正常提交
      let param = {
        ...this.baseInForm,
      };
      // for (let key in this.defaultBaseInForm) {
      //   if (this.baseInForm[key] || this.baseInForm[key] == 0) {
      //     eval("param." + key + "='" + this.baseInForm[key] + "'");
      //   } else {
      //     eval("param." + key + "=''");
      //   }
      // }
      // if (this.baseInForm.carrierId)
      //   param.carrierId = this.baseInForm.carrierId;
      // let Arr = ["provinceName", "cityName"];
      // for (let i in Arr) {
      //   let p = Arr[i];
      //   param[p] = param[p].replace(/[0-9]+/g, "");
      // }
      // param.contractEndDate = param.contractEndDate
      //   ? `${param.contractEndDate} 23:59:59`
      //   : "";
      // param.contractStartDate = param.contractStartDate
      //   ? `${param.contractStartDate} 00:00:00`
      //   : "";
      if (param.carrierId) {
        // 修改接口
        this.$API.carrierudpateCarrier(param).then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message);
            this.RELOADPAGE();
          }
        });
      } else {
        // 新增接口
        this.$API.carrieraddCarrier(param).then((res) => {
          if (res.data.status === "success") {
            this.$message.success(res.data.message);
            this.RELOADPAGE();
          }
        });
      }
    },
    RELOADPAGE() {
      this.$emit("RELOADPAGE");
    },
  },
};
</script>
<style scoped lang="less">
#baseInfo {
  margin: 60px 40px;
  .disFlexs {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .selectAddress {
    border: 1px solid #ccc;
    margin-right: 10px;
    width: 180px !important;
  }
  .addressDetails {
    //   width: 380px !important;
    flex: 1;
  }
  .btmBtns {
    text-align: center;
    margin-top: 50px;

    .saveBtns {
      font-size: 16px;
    }
  }
}
.disFlex {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
